export default __webpack_public_path__ + "static/media/main hall 2.e4aa27df.jpg";